import {Component, Input, OnInit} from '@angular/core';
import {MeasurementListComponent} from "../measurement-list/measurement-list.component";
import {MeasurementData} from "../MeasurementDataList";
import {MeasurementDescription} from "../MeasurementDescriptionList";
import {MeasurementItemComponent} from "../measurement-item/measurement-item.component";

@Component({
  selector: 'app-meting-item-details',
  templateUrl: './measurement-item-details.component.html',
  styleUrls: ['./measurement-item-details.component.css']
})
export class MeasurementItemDetailsComponent implements OnInit {
  @Input()
  public measurementData: MeasurementData = new MeasurementData();
  @Input()
  public measurementDescription: MeasurementDescription = new MeasurementDescription();
  @Input()
  fullChannelNumber: number = -1;
  status: string = "";

  constructor() { }

  ngOnInit(): void {
  }

  GetHardwareChannel(): string{
    let channelNr: number =  Math.floor( (this.fullChannelNumber) / 2 ) + 1 ;
    let channelA: string  = ((Math.floor( this.fullChannelNumber) % 2)==1) ? "A" : "-"
    let oldStyleChannel: string = channelNr + channelA;
    return oldStyleChannel;
  }



  Status(status: number ): string
  {
    return String.fromCharCode(status);
  }


}
